<!--
    @修改人：黎柏祺
    @修改时间：2018-12-13
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 谢汉
    @创建时间: 2018-07-06
    @版本:v1.0.18
    @描述: 登录日志页
    -->
<template>
  <div class="loginLog__content">
    <el-form ref="form" :model="form" :inline="true" input-width="auto">
      <el-form-item :label="$t('loginLog.userName')">
        <el-input v-model="form.userName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('loginLog.loginTime')">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          value-format="timestamp">
        </el-date-picker>
        {{$t('common.to')}}
        <el-date-picker
          v-model="form.endTime"
          type="datetime"
          value-format="timestamp">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="e_search" v-g-rac="gRac('loginLog@search')">{{ $t('common.search') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
    </el-table-extend>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import loginLogBiz from '@/logic/systemSetting/loginLogBiz'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac, dic, table],
    data () {
      return {
        form: {
          startTime: new Date().getTime() - 86400000,
          endTime: '',
          userName: ''
        },
        statuDic: {}
      }
    },
    methods: {
      initTable () {
        this.tInitTable({
          lanKey: 'loginLog.table',
          head: ['userName', 'role', 'siteName', 'ip', 'browser', 'status', 'loginTime', 'logoutTime'],
          requestFun: this.search,
          headOpt: {
            siteName: {
              formatter: 'Dictionary',
              formatterDic: this.dDictionary.remoteconfig
            },
            status: {
              formatter: 'Dictionary',
              formatterDic: this.statuDic
            }
          }
        })
      },
      async init () {
        await this.dGetDictionaryByCode('remoteconfig')
        this.initTable()
        this.search()
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.form)
        reqData.startTime = reqData.startTime === '' ? new Date().getTime() - 86400000 : reqData.startTime
        reqData.endTime = reqData.endTime === '' ? new Date().getTime() : reqData.endTime
        if (reqData.startTime > reqData.endTime) {
          this.$message({
            message: this.$t('loginLog.timeAlert'),
            type: 'warning'
          })
          return
        }
        loginLogBiz.loginLogFindPage(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map((item) => {
              item.loginTime = TimeFormat.getFormatTime(item.loginTime)
              item.logoutTime = TimeFormat.getFormatTime(item.logoutTime)
            })
          }
          this.tData = data
        }).catch((err) => {
          console.error(err)
        })
      }
    },
    mounted () {
      this.statuDic = {
        0: this.$t('loginLog.loginSuccess'),
        1: this.$t('loginLog.loginFail')
      }
      this.init()
    }
  }
</script>